module.exports = __webpack_public_path__ + "static/media/migam.00da29eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/migam.png
// module id = 369
// module chunks = 0